import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import { updateMeta } from "../../store/actions/metaAction";
import { Col, Row, Container } from "reactstrap";
import { v4 } from "uuid";

const FaqsCreate = () => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [faq, setFaq] = useState({
		question: { ar: "", en: "" },
		answer: { ar: "", en: "" },
	});
	const [loading, setLoading] = useState(false);
	const [picture, setPicture] = useState({
		blob: true,
		path: userPlaceholder,
		placeholder: true,
	});
	const dispatch = useDispatch();

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "اضافة سؤال جديد",
				breadcrumb: "الاسئلة الشائعة",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
	};

	useEffect(() => {
		onStart();
	}, []);

	const handlePicture = e => {
		const fileInput = document.querySelector(`#${e.target.id}`);
		try {
			setPicture({
				path: URL.createObjectURL(fileInput.files[0]),
				blob: true,
				placeholder: false,
			});
		} catch (error) {}
	};
	const handleSubmit = e => {
		e.preventDefault();

		// التحقق من الحقول
		if (
			!faq.question?.ar.trim() ||
			!faq.question?.en.trim() ||
			!faq.answer?.ar.trim() ||
			!faq.answer?.en.trim()
		) {
			toast.error("يرجى ملء جميع الحقول باللغة العربية والإنجليزية");
			return;
		}

		// في حال مر التحقق، يتم تنفيذ الطلب
		axios
			.post(
				`${process.env.REACT_APP_API_URL}pages/faqs/sections`,
				{
					section: { title: "faq", ...faq },
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(_ => {
				toast.success("تم إضافة السؤال بنجاح");
				history.push("/faqs/index");
			})
			.catch(_ => toast.error("حدث خطأ!"));
	};

	return (
		<section>
			<Container>
				<div className="card">
					<div className="card-body">
						<Row style={{ marginTop: "2rem" }}>
							<Col md={6} xs={12}>
								<div
									className="form-item"
									style={{
										display: "flex",
										flexDirection: "column",
										justifyContent: "flex-start",
										alignItems: "flex-start",
									}}
								>
									<label htmlFor="questionAr">السؤال باللغة العربية </label>

									<input
										type="text"
										id="questionAr"
										name="questionAr"
										value={faq?.question?.ar ?? ""}
										onChange={e => {
											setFaq({
												...faq,
												question: { ...faq.question, ar: e.target.value },
											});
										}}
									/>
								</div>
							</Col>

							<Col md={6} xs={12}>
								<div
									className="form-item"
									style={{
										display: "flex",
										flexDirection: "column",
										justifyContent: "flex-start",
										alignItems: "flex-start",
									}}
								>
									<label htmlFor="questionEn">السؤال باللغة الانجليزية </label>

									<input
										type="text"
										id="questionEn"
										name="questionEn"
										value={faq?.question?.en ?? ""}
										onChange={e => {
											setFaq({
												...faq,
												question: { ...faq.question, en: e.target.value },
											});
										}}
									/>
								</div>
							</Col>
						</Row>

						<Row>
							<Col xs={12} md={6}>
								<div className="form-item">
									<label htmlFor="faqAR">الاجابة باللغة العربية </label>

									<textarea
										name=""
										id="faqAR"
										rows="5"
										style={{ resize: "none", width: "100%" }}
										value={faq?.answer?.ar ?? ""}
										onChange={e => {
											setFaq({
												...faq,
												answer: { ...faq.answer, ar: e.target.value },
											});
										}}
									></textarea>
								</div>
							</Col>
							<Col xs={12} md={6}>
								<div className="form-item">
									<label htmlFor="faqEN"> الاجابة باللغة الانجليزية </label>

									<textarea
										name=""
										id="faqEN"
										rows="5"
										value={faq?.answer?.en ?? ""}
										style={{ resize: "none", width: "100%" }}
										onChange={e => {
											setFaq({
												...faq,
												answer: { ...faq.answer, en: e.target.value },
											});
										}}
									></textarea>
								</div>
							</Col>
						</Row>

						{/* <Row>
									<Col>
										<div className="form-item">
											<label htmlFor="picture">صورة العميل</label>
											<input type="file" onChange={handlePicture} id="picture" />
											<img
												src={
													picture && picture.blob
														? picture.path
														: `${process.env.REACT_APP_MAIN_URL}/${picture.path}`
												}
												alt="avatar"
												className="imagePreview-2"
											/>
										</div>
									</Col>
								</Row> */}

						<Row>
							<Col>
								<div className="form-item mt-3">
									<button
										className="bt bt-success btn-block"
										onClick={handleSubmit}
									>
										ارسال
									</button>
								</div>
							</Col>
						</Row>
					</div>
				</div>
			</Container>
		</section>
	);
};

export default FaqsCreate;
